import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { clientNames, crossmintModalService } from "@crossmint/client-sdk-base";
import { ethers } from "ethers";
import { reactive, ref } from "vue";
import { useBaseProps } from "@/composables/useBaseProps";
import { useCollectibleSDK } from "@/composables/useCollectibleSDK";
import { useMessaging } from "@/composables/useMessaging";
import { useStore } from "@/composables/useStore";
import { CROSSMINT_ADDRESS, CROSSMINT_ENVIRONMENT_MAP } from "@/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CrossmintPayButton',
  props: {
    disabled: { type: Boolean },
    purchaseQuantity: {},
    recaptchaToken: {}
  },
  setup(__props: any) {

const props = __props;

const messaging = useMessaging();

const baseProps = useBaseProps();
const collectibleSDK = useCollectibleSDK();
const store = useStore();

const mintConfig = reactive<{
  type: "erc-721" | "erc-1155";
  message: string;
  signature: string;
  nonce: string;
}>({
  type: store.isERC721 ? "erc-721" : "erc-1155",
  message: "",
  signature: "",
  nonce: "",
});

const getValidation = async () => {
  const validation: any = await collectibleSDK.dataProviders.collectibleServerAPI.getValidation(
    store.collectibleAddress,
    CROSSMINT_ADDRESS,
    props.recaptchaToken
  );
  mintConfig.message = validation.message;
  mintConfig.signature = validation.signature;
  mintConfig.nonce = validation.nonce;
};

const connecting = ref(false);
const setConnecting = (conn: boolean) => {
  connecting.value = conn;
};

const { connect } = crossmintModalService({
  environment: CROSSMINT_ENVIRONMENT_MAP[baseProps.network],
  clientId: store.crossmintClientId,
  showOverlay: true,
  dismissOverlayOnClick: false,
  setConnecting: setConnecting,
  libVersion: "0.1.0",
  clientName: clientNames.vanillaUi,
});

const click = async () => {
  await getValidation();
  connect(
    {
      totalPrice: ethers.utils.formatEther(
        store.price.mul(ethers.BigNumber.from(props.purchaseQuantity.toString()))
      ),
      amount: props.purchaseQuantity,
      ...mintConfig,
    },
    store.walletAddress,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined
  );
};

const buttonText = messaging.BUY_BUTTON_WITH_CARD_CTA;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "m-crossmint-button",
    disabled: props.disabled,
    onClick: click
  }, _toDisplayString(_unref(buttonText)), 9, _hoisted_1))
}
}

})